import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationIndividual5MasterReferenceData = createAsyncThunk(
  'stop/getVerificationIndividual5MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationIndividual5MasterReferenceSlice = createSlice({
  name: 'stop/verificationIndividual5MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationIndividual5MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationIndividual5MasterReferenceData.fulfilled]: (
      state,
      action
    ) => action.payload,
  },
});

export const { resetVerificationIndividual5MasterReference } =
  verificationIndividual5MasterReferenceSlice.actions;

export default verificationIndividual5MasterReferenceSlice.reducer;
